// extracted by mini-css-extract-plugin
export default {"color":"InputColor_color__i6DSx","colorButton":"InputColor_colorButton__uDhgH"};